import React from "react";
import {Translation as T} from "@awe-web/shared/lib";
import SelectStationAndTime from "../../../stations/components/select_station_and_time";
import {ScreenSection, ScreenHeading} from "../../../components/screen.js";
import {TypeArea} from "../../../components/layout.js";
import {B2cPromotion} from "../../../promotion/components/promotion";

const SELECT_STATION_AND_TIME = "FSD0000080";

export default function B2C_SelectStationAndTime() {
  return (
    <div className="select-station-and-time">
      <ScreenSection main dark>
        <TypeArea>
          <ScreenHeading><T code={SELECT_STATION_AND_TIME} /></ScreenHeading>
          <SelectStationAndTime reservationPath="B2C" />
        </TypeArea>
      </ScreenSection>

      <ScreenSection light>
        <TypeArea>
          <B2cPromotion />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
